import React, {Fragment, useState, useEffect, memo} from 'react';
import Val from "./ValueObj";
import Key from "./KeyObj";
import {valueType} from "../utils/json";

const KeyValPair = memo(({keyVal, value, collapseAll}) => {
    const [keyClicked, setKeyClicked] = useState(false)

    useEffect(()=>{
        setKeyClicked(collapseAll)
    }, [collapseAll])

    const valType = valueType(value)
    const arraySize = Array.isArray(value) ? value.length : null

    return (
        <Fragment>
            <Key keyVal={keyVal}
                 valType={valType}
                 keyClicked={keyClicked}
                 setKeyClicked={setKeyClicked}
                 arraySize={arraySize}
            />
            <td><Val value={value} keyClicked={keyClicked} collapseAll={collapseAll}/></td>
        </Fragment>
    )
})


export default KeyValPair;
